import { render } from "./LoginForm_08_05.vue?vue&type=template&id=1c3874dd&scoped=true"
import script from "./LoginForm_08_05.vue?vue&type=script&lang=js"
export * from "./LoginForm_08_05.vue?vue&type=script&lang=js"

import "./LoginForm_08_05.vue?vue&type=style&index=0&id=1c3874dd&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c3874dd"]])

export default __exports__